import { END_POINTS } from '@config';
import ApiTags from '@constants/api-tags';
import { api } from '@core/baseApi';
import { OrgAndBranchId } from '@types';

import { DynamicComponentsResponse } from '../types';

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDynamicComponents: builder.query<
      DynamicComponentsResponse,
      OrgAndBranchId
    >({
      query: ({ organizationId, branchId }) => ({
        url: END_POINTS.ORGANIZATION.GET_DYNAMIC_COMPONENTS({
          organizationId,
          branchId
        }),
        method: 'GET',
        params: { platform: 'payee_web' }
      }),
      providesTags: [ApiTags.DYNAMIC_COMPONENTS]
    })
  })
});

export const { useGetDynamicComponentsQuery } = extendedApi;

export default extendedApi;
